import { render, staticRenderFns } from "./emailBlog.vue?vue&type=template&id=1020115e&"
import script from "./emailBlog.vue?vue&type=script&lang=js&"
export * from "./emailBlog.vue?vue&type=script&lang=js&"
import style0 from "./emailBlog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports